import * as React from "react";
import { useCallback } from "react";
import { Row, Col } from "components/bootstrap";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { ErrorsProvider } from "components/lookup-tables/contexts/ErrorsContext";
import { useFetchCaches } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { cacheListElements } from "./constants";
import columnRenderers from "./column-renderers";
import useActions from "./use-actions";
const queryHelpComponent = /* @__PURE__ */ React.createElement(
  QueryHelper,
  {
    entityName: "cache",
    commonFields: ["id", "title", "name", "description"],
    example: /* @__PURE__ */ React.createElement("p", null, "searching without a field name matches against the ", /* @__PURE__ */ React.createElement("code", null, "title"), " field:", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "geoip"), " ", /* @__PURE__ */ React.createElement("br", null), "is the same as", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, "title:geoip"))
  }
);
function CacheList() {
  const { fetchPaginatedCaches, cachesKeyFn } = useFetchCaches();
  const { renderActions } = useActions();
  const handleFetchCaches = useCallback(
    async (searchParams) => {
      var _a;
      const resp = await fetchPaginatedCaches(searchParams);
      const overrides = {
        title: { sortable: true },
        name: { sortable: true },
        description: { sortable: false }
      };
      const expectedIds = cacheListElements.defaultLayout.defaultDisplayedAttributes;
      const attrMap = /* @__PURE__ */ new Map();
      ((_a = resp.attributes) != null ? _a : []).forEach((attr) => {
        var _a2;
        const override = (_a2 = overrides[attr.id]) != null ? _a2 : {};
        attrMap.set(attr.id, { ...attr, ...override });
      });
      expectedIds.forEach((id) => {
        var _a2;
        if (!attrMap.has(id)) {
          const override = (_a2 = overrides[id]) != null ? _a2 : {};
          attrMap.set(id, {
            id,
            title: id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
            type: "STRING",
            ...override
          });
        }
      });
      return Promise.resolve({
        ...resp,
        attributes: Array.from(attrMap.values())
      });
    },
    [fetchPaginatedCaches]
  );
  return /* @__PURE__ */ React.createElement(ErrorsProvider, null, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "caches",
      entityActions: renderActions,
      queryHelpComponent,
      tableLayout: cacheListElements.defaultLayout,
      fetchEntities: handleFetchCaches,
      keyFn: cachesKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers
    }
  ))));
}
export default CacheList;
